import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
//material components
import {withData} from "../../containers/DataContainer";
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Switch from '@material-ui/core/Switch';
//custom components
import CustomSignOut from '../Auth/CustomSignOut';

function AdminTopNavbar(props) {
  const { classes, data, title, menuOpen, menuClick, setTheme } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const showOptions = event => setAnchorEl(event.currentTarget);
  const hideOptions = () => setAnchorEl(null);
  const changeTheme = () => data.theme === 'dark' ? setTheme('light') : setTheme('dark');

  const optionsOpen = Boolean(anchorEl);
  return (
    <AppBar position="absolute" className={classNames(classes.appBar, menuOpen && classes.appBarShift)}>
      <Toolbar variant="dense" className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={menuClick}
          className={classNames(classes.menuButton, menuOpen && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" color="inherit" noWrap className={classes.grow}>
          {title}
        </Typography>
        <div>
          <IconButton aria-owns={optionsOpen ? 'menu-appbar' : undefined} aria-haspopup="true" onClick={showOptions} color="inherit">
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'left'}}
            transformOrigin={{ vertical: 'top', horizontal: 'right'}}
            open={optionsOpen}
            onClose={hideOptions}
          >
            <MenuItem onClick={hideOptions}>Olá, {data.user.name}</MenuItem>
            <MenuItem>Tema escuro <Switch
              checked={data.theme === 'dark'}
              onClick={changeTheme}
            /></MenuItem>
            <CustomSignOut>
              <MenuItem>Sair</MenuItem>
            </CustomSignOut>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}

AdminTopNavbar.propTypes = {
  classes: PropTypes.object.isRequired,
  menuClick: PropTypes.func.isRequired,
  menuOpen: PropTypes.bool,
  data: PropTypes.object.isRequired,
  title: PropTypes.string
};

const styles = theme => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: theme.spacing.unit * 30,
    width: `calc(100% - ${theme.spacing.unit * 30}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  menuButtonHidden: {
    display:  'none'
  },
});

export default withData(withStyles(styles)(AdminTopNavbar));